import React, { useEffect, useState } from "react";
import api, { API } from "../../lib/api";
import { Receipt, FilePdf } from "@phosphor-icons/react";

export default function MyInvoices() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/portal/invoices").then((r)=>setItems(r.data)); }, []);

  return (
    <div data-testid="my-invoices">
      <h1 className="text-3xl sm:text-4xl font-black tracking-tighter" style={{fontFamily:"Manrope, sans-serif"}}>Invoices</h1>
      <p className="text-sm text-zinc-500 mt-1">Your billing history with us.</p>

      <div className="mt-8 space-y-3">
        {items.length === 0 && (
          <div className="bg-white border border-zinc-200 rounded-sm p-10 text-center text-sm text-zinc-500">No invoices issued yet.</div>
        )}
        {items.map((i) => (
          <div key={i.id} className="bg-white border border-zinc-200 rounded-sm p-5" data-testid={`p-inv-${i.id}`}>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Receipt size={22} weight="duotone" color="#E60000"/>
                <div>
                  <div className="font-bold text-zinc-900">INV-{i.id.slice(0,6).toUpperCase()}</div>
                  <div className="text-xs text-zinc-500">{i.created_at?.slice(0,10)}</div>
                </div>
              </div>
              <span className={`text-[10px] uppercase tracking-[0.2em] font-bold px-2 py-0.5 rounded-sm ${
                i.status === "paid" ? "bg-green-100 text-green-700"
                : i.status === "partial" ? "bg-yellow-100 text-yellow-700"
                : "bg-red-100 text-red-700"
              }`}>{i.status}</span>
            </div>
            <div className="mt-3 flex items-center justify-end">
              <a href={`${API}/invoices/${i.id}/pdf`} target="_blank" rel="noopener noreferrer"
                 className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-700 hover:text-[#E60000] inline-flex items-center gap-1"
                 data-testid={`portal-pdf-${i.id}`}>
                <FilePdf size={14} weight="bold"/> Download PDF
              </a>
            </div>
            <div className="mt-4 grid grid-cols-3 gap-4 text-sm">
              <div><div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500">Total</div><div className="font-bold">â‚¹{i.total.toFixed(0)}</div></div>
              <div><div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500">Paid</div><div className="font-bold text-green-700">â‚¹{i.paid.toFixed(0)}</div></div>
              <div><div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500">Balance</div><div className="font-bold text-[#E60000]">â‚¹{i.balance.toFixed(0)}</div></div>
            </div>
            {(i.items || []).length > 0 && (
              <div className="mt-4 border-t border-zinc-100 pt-3 text-xs text-zinc-600 space-y-1">
                {i.items.map((it, idx) => (
                  <div key={idx} className="flex justify-between">
                    <span>{it.description} Ã— {it.quantity}</span>
                    <span>â‚¹{(it.quantity * it.unit_price).toFixed(0)}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
